//import React from 'react';
//import { MapPinHouse, Map } from "lucide-react";
//import { FaMap } from "react-icons/fa6";
//import { FaArrowsToEye, FaStreetView} from "react-icons/fa6";
//import { PiMapPinAreaFill } from "react-icons/pi";
//import { TbMapUp, TbMapSearch } from "react-icons/tb";
import { TbMapSearch } from "react-icons/tb";

//import "./ImageGrid.css";
import "./ImageCell.css";

const ImageCellSVbutton = ({ onClick, bgColor }) => {
  return (
    <>
      <button
        className="image-action-btn"
        onClick={onClick}
        title="voir dans StreetView"
        style={{ backgroundColor: bgColor }}
      >
        <TbMapSearch size={20} strokeWidth={2} />
      </button>
    </>
  );
};

export default ImageCellSVbutton;
/*

<MapPinHouse />
<LocateFixed />
<Target />
<Eye />
<MapPinned />

*/
